import {HeaderTitle} from "../../../common/HeaderTitle.jsx";
import {useNavigate, useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import {createForm} from "../../../utils/generators/createForm.jsx";
import {Button, Container} from "react-bootstrap";
import {useEffect, useState} from "react";
import {usePozycjaSlownika} from "../../../../api/domain/slowniki/queries/usePozycjaSlownika.jsx";
import {useDodajPozycjeSlownika} from "../../../../api/domain/slowniki/mutations/useDodajPozycjeSlownika.jsx";
import {useModyfikujPozycjeSlownika} from "../../../../api/domain/slowniki/mutations/useModyfikujPozycjeSlownika.jsx";

const ViewEdycjaPozycjiSlownika = () => {
    const {tryb, id: slownik, pozycjaId} = useParams()
    const titleName = `Edycja pozycji ${pozycjaId} dla słownika '${slownik}'`;
    const bluePrintBase = useSelector(state => state.slownikFormSelected)

    const pozycjaSlownika = usePozycjaSlownika(slownik, pozycjaId,  tryb !== 'dodaj')
    const dodajPozycjeSlownika = useDodajPozycjeSlownika()
    const modyfikujPozycjeSlownika = useModyfikujPozycjeSlownika()

    const [formData, setFormData] = useState({...pozycjaSlownika?.data})
    const form = createForm(bluePrintBase?.data?.cols, {form: formData, setForm: setFormData})

    const func = tryb === 'dodaj' ? dodajPozycjeSlownika.mutate : modyfikujPozycjeSlownika.mutate
    const navigate = useNavigate()


    if (!bluePrintBase?.name) navigate('/oper/slowniki/lista')

    useEffect(() => {
        if (tryb === 'dodaj') {
            setFormData({})
        } else {
            setFormData({...pozycjaSlownika?.data})
        }

        return () => {
            setFormData({})
        }
    }, [tryb, pozycjaSlownika?.data, pozycjaId, slownik])

    return (
        <div>
            <HeaderTitle
                breadcrumbLinks={[
                    {label: `Wszystkie słowniki`, to: '/oper/slowniki/lista'},
                    {
                        label: `Wszystkie pozycje słownika '${slownik}'`,
                        to: `/oper/slownik/${slownik}/lista`
                    },
                    {label: titleName},
                ]}
                home
                destination={`/oper/slownik/${slownik}/lista`}
                size={'fs-3'}
                nav
                title={titleName}/>
            <Container className={'d-flex flex-column gap-3'}>
                {/* // eslint-disable-next-line */}
                {form}
                <Button
                    onClick={() => func({slownik, data: formData})}
                    className={'align-self-start'}>
                    {tryb === 'dodaj' ? 'Dodaj' : 'Zapisz zmiany'}
                </Button>
            </Container>
        </div>
    );
}

export default ViewEdycjaPozycjiSlownika;